module.exports = __webpack_public_path__ + "static/media/trinidad-and-tobago.e291cd44.svg";